<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('anquanzhongxin')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="cu-list menu">
			<div class="cu-item bg-gradual-black" @click="changeChangePassword">
				<div class="content">
					<text class="cauIcon-questionfill  text-gold">
						<van-icon name="edit" />
						<span></span>
					</text>
					<text class=" text-gold">
						<span>{{$t('xiugaidenglu')}}</span>
					</text>
					<text style="float: right;" class="iconfont icon-right text-gold">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
			<div class="cu-item bg-gradual-black" @click="changeSetSecurityCode">
				<div class="content">
					<text class="cauIcon-questionfill text-gold">
						<van-icon name="edit" />
						<span></span>
					</text>
					<text class="text-gold">
						<span>{{$t('anquan1')}}</span>
					</text>
					<text style="float: right;" class="iconfont icon-right text-gold">
						<van-icon name="arrow" />
						<span></span>
					</text>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Rule",
		components: {},
		data() {
			return {};
		},
		methods: {
			changego() {
				this.$router.go(-1);
			},
			changeChangePassword() {
				this.$router.push({
					path: "/changePassword",
				});
			},
			changeSetSecurityCode() {
				// userApi.safetyInfo().then((data) => {
				//   console.log(data.data.isTrue);
				//   let isTrue = data.data.isTrue;
				this.$router.push({
					path: "/setSecurityCode",
					// query: {
					//   isTrue: isTrue,
					// },
				});
				// });
			},
		}
	};
</script>

<style>
	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}
</style>